<template>
  <PagedCategory />
</template>

<script>
import PagedCategory from './page/_page'
export default {
  components: {
    PagedCategory,
  },
}
</script>
